module.exports = __webpack_public_path__ + "static/media/carpet-white.346b2459.svg";